<template>
	<div id="description-page" v-if="isDisplaying">
		<section class="breadcrumb-section mb-3">
			<div class="container oversized-container">
				<span>Producto</span>
				<span class="line">/</span>
				<span>{{ product.nombre }}</span>
			</div>
		</section>

		<!-- {{product.vendedores_id}} -->

		<section class="container oversized-container description-section" v-if="!!product.vendedores_id"
			id="product-description">
			<div class="row">

				<!-- IMAGE GALLERY -->

				<div id="productGallery" class="col-lg-5 col-md-6 col-gallery mb-5" v-if="showGallery">
					<img v-for="(row, galIndex) in product.gallery" :key="galIndex" :src="row" @click="openGLightBox"
						:class="{ 'glightbox': true }" />
				</div>

				<!-- MAIN FORM -->

				<div class="col-lg-7 col-md-6 col-description">

					<b-form @submit.prevent="addCart">

						<div class="small-padding title-holder">
							<seller-belt :vendedores-id="product.vendedores_id" />

							<h1 class="name">{{ product.nombre }}</h1>

							<template v-if="!!product.sku">
								<h6 class="mt-2 subtitle">SKU</h6>

								<h6 class="sku">
									{{ product.sku }}
								</h6>
							</template>

							<h4 class="price">{{ product.precio | currency }}</h4>
						</div>


						<div class="small-padding">
							<h6 class="mt-2 subtitle">Marca</h6>
							<div class="txt-description">{{ product.marca }}</div>

							<h6 class="mt-2 subtitle">Condición</h6>
							<div class="txt-description">{{ product.condicion }}</div>
						</div>


						<div class="small-padding description-holder">
							<!-- TITLE -->
							<h6 class="subtitle">
								<div class="row tappable" @click="toggleFullDescription" style="cursor: pointer;">
									<div class="col">
										Descripción
									</div>
									<div class="col text-right">
										<span class="toggle-description">
											<!-- {{ fullDescripcion ? 'Ver menos' : 'Ver más' }}	 -->
											<i class="fa fa-chevron-right" v-if="!fullDescripcion"></i>
											<i class="fa fa-chevron-down" v-if="fullDescripcion"></i>
										</span>
										<!-- <i class="fa fa-info-circle" aria-hidden="true" title="La descripción puede ser ampliada o reducida haciendo clic en 'Ver más' o 'Ver menos'"></i> -->
									</div>
								</div>
							</h6>
							<!-- DESCRIPTION TEXT -->
							<div class="description-holder-content txt-description">
								<template v-if="fullDescripcion">
									{{ product.descripcion }}
								</template>
								<template v-else>
									{{ product.descripcion | truncate(descriptionTruncationLimit) }}
								</template>
							</div>
						</div>

						<div class="small-padding">

							<h6 class="mb-1 subtitle">Cantidad</h6>

							<div class="col-quantity2">
								<a class="form-control btn-q" @click="changeCantidad(-1)">
									<i class="fas fa-minus"></i>
								</a>
								<b-form-input class="input-q" type="number" min="1" v-model="form.quantity"
									@keypress="isNumber($event)" />
								<a class="form-control btn-q" @click="changeCantidad(1)">
									<i class="fas fa-plus"></i>
								</a>
							</div>

							<p class="note">
								<template v-if="product.cantidad == 1">1 Disponible</template>
								<template>{{ product.cantidad }} Disponibles</template>
							</p>

							<div class="d-block mt-4 mb-2">
								<b-button type="submit" class="my-2 my-xl-0 btn-submit">
									Agregar al carrito
									<i class="fas fa-shopping-cart"></i>
								</b-button>
							</div>

						</div>

					</b-form>

					<hr />

					<preguntas-y-respuestas :productId="product.productos_id" v-if="!!product.productos_id" />
				</div>

			</div>
		</section>

		<productos-relacionados :productId="product.productos_id" />

	</div>
</template>

<script>
// import vZoom from "vue-zoom"; // https://www.npmjs.com/package/vue-zoom
import axios from 'axios';
import { mapActions } from 'vuex';
import SellerBelt from '../daniel/seller-belt.vue';
import swal from 'sweetalert'
import PreguntasYRespuestas from './preguntasYRespuestas.vue';
import ProductosRelacionados from './productosRelacionados.vue';
import GLightBox from "glightbox"; // https://github.com/biati-digital/glightbox
import { mixedMSG } from '@@/utils.js'
import { truncate } from 'lodash';

require("glightbox/dist/css/glightbox.min.css");

export default {
	props: {
		descriptionTruncationLimit: {
			type: Number,
			default: 50,
		},
		productFetchingAPI: {
			type: String,
			default: 'catalogo/getitem/',
		},
	},
	computed: {
		fullGalleryComplete() {
			return _.map(this.product.gallery, comp => {
				return {
					href: (comp),
					width: '100px',
					type: 'image'
				}
			})
		},
	},
	components: {
		// vZoom,
		SellerBelt,
		PreguntasYRespuestas,
		ProductosRelacionados
	},

	data() {
		return {
			id: null,
			isDisplaying: false,
			showGallery: true,
			fullDescripcion: false,

			form: {
				productId: null,
				quantity: 1,
			},

			product: {
				descripcion: ""
			},

			lBox: null,

			gallery: [],

		};
	},

	methods: {
		...mapActions(['catalogGetProductByID', 'cartAdd']),
		toggleFullDescription() {
			this.fullDescripcion = !this.fullDescripcion;
		},
		openGLightBox() {
			try {
				this.lBox = new GLightBox({
					elements: this.fullGalleryComplete,
					// touchNavigation: false,
					// startAt: this.product.gallery[],
					loop: true
				});
				this.lBox.open();
			} catch (e) {
				console.log('openGLightBox.e', e)
			}
		},
		async initProductDetail() {
			this.isDisplaying = false;
			try {
				// this.product = await this.catalogGetProductByID(this.$route.params.id)
				this.form.productId = this.$route.params.id
				const response = await axios.get(this.productFetchingAPI + this.$route.params.id)
				if (!_.isObjectLike(response.data))
					throw ('Respuesta inválida del servidor')
				mixedMSG(response.status, response.msg, response.class);
				this.product = response.data.product;
				console.log('Product fetch response:', response);
			} catch (e) {
				console.error(e)
			} finally {
				this.isDisplaying = true;
			}
		},
		changeCantidad(mod) {
			let qty = _.clone(this.form.quantity);

			if (!_.isNumber(qty)) {
				qty = 1
			}

			qty += mod

			if (qty == 0) {
				qty = 1;
			} if (qty > parseInt(this.product.cantidad)) {
				qty = parseInt(this.product.cantidad);
			}
			this.form.quantity = qty;
		},
		async trigger() {
			try {

				let adding = {
					product: this.product,
					vendedores_id: this.product.vendedores_id,
					productos_id: this.product.productos_id,
					cantidad: this.form.quantity
				};

				let text = await this.cartAdd(adding)

				let selected = await swal({
					text,
					icon: "success",
					buttons: {
						cancel: "Continuar",
						go_to_pay: "Ir a pagar",
					},
				})

				if (selected == "go_to_pay") {
					this.$router.push({
						name: "Cart",
					});
				}
			} catch (e) {
				swal({
					text: e,
					icon: "warning",
				});
				console.error(e)
			}
		},
		addCart() {
			this.trigger()
		}
	},

	mounted() {
		this.initProductDetail()
	},

	watch: {
		'$route'() {
			this.initProductDetail()
		}
	}
};
</script>

<style lang="less">
#description-page {

	#productGallery {

		img {
			width: 100%;
			height: auto;
			display: none;
			object-fit: contain;
			// max-height: 45em;

			&:first-child {
				display: inherit;
				border: 1px solid var(--primary-light);
				border-radius: 0.3em;
				box-shadow: 0em 0.5em 1em hsla(0, 0%, 0%, 0.25);
			}
		}
	}

	.small-padding {
		padding: 0.5em;
	}

	.description-holder {
		background-color: var(--dimmed-light);
		border-radius: 0.5em;
		border: 1px solid #dbdbdb;
	}

	.note {
		font-size: 0.8em;
		color: var(--black-dimmed);
	}

}
</style>

<style lang="scss">
@import '@/sass/utils/toolbox';
@import '@/sass/utils/_variables';

#description-page {
	padding-bottom: 20px;

	.description-section {

		.col-description {
			.bar-fav {
				position: relative;
				display: inline-block;
				width: 100%;
				height: 1px;

				.btn-fav {
					position: absolute;
					padding: 0;
					bottom: -20px;
					right: 0;
					width: 40px;
					height: 40px;
					border: 0;
					background-color: transparent;

					.icon {
						display: inline-block;
						width: 100%;
						height: 100%;
						background-repeat: no-repeat;
						background-size: contain;
						background-position: center;
						background-image: url('../images/shared/favorite-icon.svg');
					}

					&.actived,
					&:hover {
						.icon {
							background-image: url('../images/shared/favorite-filled-icon.svg');
						}
					}
				}

				@media screen and (max-width: 575px) {
					.btn-fav {
						padding: 11px;
						margin-right: 8px;
						bottom: 14px;
						width: 50px;
						height: 50px;
						background-color: #fff;
						border-radius: 50%;
						box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4) !important;

						.icon {
							margin-top: 2px;
						}
					}
				}
			}

			.box-seller {
				display: flex;
				flex-wrap: wrap;
				flex: 0 0 100%;
				max-width: 100%;
				margin-bottom: 10px;
				color: #383838;
				align-items: center;
				text-decoration: none !important;

				&:hover {
					opacity: 0.85;
				}

				.col-logo {
					padding: 0;
					max-width: 52px;

					.image {
						display: block;
						border-radius: 50%;
						border: 1px solid rgba(0, 0, 0, 0.60);
						background-color: #ffffff;
						background-position: center;
						background-repeat: no-repeat;
						background-size: 90%;

						img {
							width: 100%;
						}
					}
				}

				.col-name {
					padding-left: 8px;

					h5 {
						font-size: 1.15rem;
						font-weight: 600;
					}
				}
			}

			>.brand {
				margin-bottom: 5px;
				color: #959595;
				font-weight: 400;
			}

			>.name {
				color: $green;
				font-size: 1.7rem;
			}

			>.sku {
				margin-top: 2px;
				margin-bottom: 8px;
				color: #4a4949;
			}

			>.price {
				color: $green;
				font-size: 1.7rem;

				del {
					color: #7f8086;
					font-size: 76%;
				}
			}

			>.discount {
				color: #a6a3a3;
				text-decoration: line-through;

				span {
					font-size: 88%;
				}
			}

			.subtitle {
				color: #313030;
				font-size: 0.97rem;
				font-weight: 600;
			}

			.box-delivery-info {
				display: block;

				.box {
					position: relative;
					display: inline-block;
					padding: 7px 20px 5px 20px;
					color: $green;
					font-size: 0.95rem;
					font-weight: 600;
					letter-spacing: 1px;
					// text-transform: uppercase;
					border: 2px solid $green;
					border-radius: 3px;
					background-color: #dce7f4;

					div {
						display: inline-block;
					}

					.truck-icon {
						position: relative;
						display: inline-block;
						margin-right: 9px;
						width: 20px;
						height: 23px;

						i {
							position: relative;
							top: 1px;
							font-size: 120%;
							color: $green;
						}
					}
				}
			}

			.txt-description {
				margin-bottom: 10px;
				color: #828282;
				font-size: 0.9rem;
				line-height: 1.4;
				text-align: justify;
				white-space: pre-line;

				p {
					margin-bottom: 4px;

					&:last-child {
						margin-bottom: 0;
					}
				}
			}

			.col-quantity2 {
				display: flex;

				.input-q {
					padding-top: 7px;
					padding-left: 3px;
					padding-right: 3px;
					width: 45px;
					height: 34px;
					font-family: Arial, "Noto Sans", sans-serif;
					font-size: 1.0rem;
					font-weight: 600;
					text-align: center;
					border: 0;
					border-top: 1px solid $green;
					border-bottom: 1px solid $green;
					border-radius: 0;
				}

				.btn-q {
					height: 34px;
					padding-top: 6px;
					padding-bottom: 6px;
					width: 40px;
					color: $green;
					border: 1px solid $green;
					cursor: pointer;

					&:first-child {
						border-radius: 0.25rem 0 0 0.25rem;
					}

					&:last-child {
						border-radius: 0 0.25rem 0.25rem 0;
					}
				}
			}

			.prese-options {
				>div {
					margin-left: -4px;
					margin-right: -4px;

					.custom-radio {
						display: inline-block;
						padding-left: 0;
						margin: 4px 4px;

						.custom-control-input:checked~.custom-control-label {
							.radio-prese {
								color: #ffffff;
								background-color: rgba(0, 0, 0, 0.9);
							}
						}

						.custom-control-label {

							&:before,
							&:after {
								display: none;
							}
						}

						.radio-prese {
							display: inline-block;
							padding: 5px 10px;
							min-width: 55px;
							font-size: 0.85rem;
							font-weight: 500;
							text-align: center;
							border: 1px solid rgba(0, 0, 0, 0.2);
							border-radius: 4px;
							cursor: pointer;
						}
					}
				}
			}

			.box-options {
				position: relative;
				padding-top: 20px;
				padding-bottom: 15px;
				width: 100%;

				.col-opts {
					margin: 4px 5px;

					&:first-child {
						margin-left: 0;
					}

					&:last-child {
						margin-right: 0;
					}
				}

				.col-sizes {
					max-width: 115px;
				}

				.col-quantity {
					max-width: 135px;
				}

				.col-extra-selects {
					max-width: 210px;
				}

				.col-selects {
					.custom-select {
						border-color: #000000;
						font-size: 0.92rem;
					}
				}
			}

			.b-form-spinbutton {
				// border-color: #000000;
			}

			.btn-submit {
				width: 210px;
				max-width: 100%;
				padding: 0.55rem 0.75rem;
				color: #fff;
				font-size: 0.85rem;
				font-weight: 400;
				border-color: $green;
				border-radius: 4px;
				background-color: $green;

				&:hover {
					border-color: $green;
					background-color: $green;
				}

				&.btn-contact {
					background-color: #353434;
					border-color: #353434;

					&:hover {
						background-color: #444343;
						border-color: #444343;
					}
				}
			}

			.col-comments {
				position: relative;
				padding: 0;
				margin-top: 24px;
				width: 100%;

				.box-comment {
					position: relative;
					width: 100%;

					h5 {
						margin-bottom: 10px;
						font-size: 1.15rem;
						font-weight: 700;
					}

					.box-stars {
						position: relative;
						display: inline-block;
						width: 100%;

						.b-rating {
							height: auto;
							padding: 0;
							// width: 230px;
							border: 0;

							.b-rating-star {
								font-size: 1.45rem;

								&:first-child {
									padding-left: 0;
								}
							}
						}
					}

					.box-input {
						position: relative;
						display: inline-block;
						margin-top: 5px;
						width: 80%;

						textarea {
							resize: none;
						}

						.btn-co {
							width: 180px;
							font-size: 1.05rem;
							font-weight: 500;
							border-color: $green;
							background-color: $green;

							&:hover {
								background-color: $green;
							}
						}
					}
				}
			}

			.col-extra {
				position: relative;
				display: inline-block;

				h6 {
					margin-bottom: 5px;
					font-size: 0.90rem;
				}

				.btn-q {
					position: relative;
					display: inline-block;
					margin: 1px 4px;
					color: #ffffff;
					border-radius: 2px;
					background: $green;
					cursor: pointer;
					@include transition(250ms);

					span {
						display: flex;
						flex-wrap: wrap;
						width: 34px;
						flex: 0 0 34px;
						max-width: 34px;
						height: 34px;
						display: flex;
						-ms-flex-pack: center !important;
						justify-content: center !important;
						-ms-flex-align: center !important;
						align-items: center !important;
					}

					&:hover {
						background-color: $green;
					}
				}

				.b-print {
					padding-left: 0;
					flex: 0 0 95px;
					max-width: 95px;
				}
			}

			@media screen and (max-width: 575px) {
				.box-seller-information {
					margin-left: -15px;
					margin-right: -15px;
					margin-top: 15px;
					padding: 20px 17px 20px 17px;
					width: auto;
					border-top: 2px solid rgba(0, 0, 0, 0.12);

					.col-info {
						max-width: calc(100% - 50px);
					}

					.col-links {
						display: none;
					}
				}

				>.name {
					font-size: 1.6rem;
				}

				>.price {
					font-size: 1.3rem;
				}

				.txt-description {
					font-size: 0.85rem;
					text-align: justify;
				}

				.btn-submit {
					padding: 0.7rem 0.75rem;
					width: 100%;
				}
			}
		}

		.col-extrainfo {
			margin-top: 20px;
			border-bottom: 2px solid rgba(0, 0, 0, .18);

			.row-info {
				border-top: 2px solid rgba(0, 0, 0, .18);

				.col-label,
				.col-txt {
					padding-top: 14px;
					padding-bottom: 14px;
				}

				.col-label {
					h5 {
						color: #222121;
						font-size: 0.95rem;
					}
				}

				.col-txt {
					color: #828282;
					font-size: 0.95rem;
					line-height: 1.3;

					p {
						margin-bottom: 4px;

						&:last-child {
							margin-bottom: 0;
						}
					}
				}
			}

			@media screen and (max-width: 991px) {
				.row-info {
					.col-label {
						padding-bottom: 0;
					}

					.col-txt {
						padding-top: 4px;
					}
				}
			}
		}
	}

	.related-products-section {
		margin-top: 50px;
	}

}

</style>